export default __webpack_public_path__ + "static/media/Loading.51afef47.gif";